import {hhmmToMinutes} from "utilities";

export const dealService = {
 /**
  * Sorts a deals array by the given strategy. Synchronous.
  *
  * @param {Object[]} deals
  * @param {string} sortBy
  * @returns {Object[]} sorted copy
  */
 sortDeals: (deals, sortBy) => {
  const dealsCopy = [...deals];

  switch (sortBy) {
   case "lowestPrice":
    dealsCopy.sort((a, b) => (a.price ?? Infinity) - (b.price ?? Infinity));
    break;

   case "closestTime": {
    const nowMinutes = new Date().getHours() * 60 + new Date().getMinutes();
    dealsCopy.sort((a, b) => {
     const aStart = hhmmToMinutes(a.timeStart || "00:00");
     const aEnd = hhmmToMinutes(a.timeEnd || "23:59");
     const bStart = hhmmToMinutes(b.timeStart || "00:00");
     const bEnd = hhmmToMinutes(b.timeEnd || "23:59");

     const aDelta =
      nowMinutes >= aStart && nowMinutes <= aEnd
       ? 0
       : aStart > nowMinutes
         ? aStart - nowMinutes
         : Infinity;

     const bDelta =
      nowMinutes >= bStart && nowMinutes <= bEnd
       ? 0
       : bStart > nowMinutes
         ? bStart - nowMinutes
         : Infinity;

     return aDelta - bDelta;
    });
    break;
   }

   case "mostLiked":
    dealsCopy.sort((a, b) => {
     const aLikes = Array.isArray(a.likedBy) ? a.likedBy.length : 0;
     const bLikes = Array.isArray(b.likedBy) ? b.likedBy.length : 0;
     return bLikes - aLikes;
    });
    break;

   case "mostViewed":
    // Uses denormalized viewCount field — zero extra reads (PERF-03 fix)
    dealsCopy.sort((a, b) => (b.viewCount ?? 0) - (a.viewCount ?? 0));
    break;

   case "highestRated":
    dealsCopy.sort((a, b) => {
     const aRating = typeof a.rating === "number" ? a.rating : 0;
     const bRating = typeof b.rating === "number" ? b.rating : 0;
     return bRating - aRating;
    });
    break;

   case "newest":
    dealsCopy.sort((a, b) => {
     const aCreated = a.createdDate?.toDate?.() || new Date(0);
     const bCreated = b.createdDate?.toDate?.() || new Date(0);
     return bCreated - aCreated;
    });
    break;

   default:
    break;
  }

  return dealsCopy;
 },
};
